import { createI18n } from "vue-i18n";
import ar from "../locales/ar.json";
import en from "../locales/en.json";

const saved =
  typeof window !== "undefined" ? localStorage.getItem("locale") : null;
// Default to Arabic if no saved preference
const initial = saved || "ar";

const messages = {
  ar,
  en,
};

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: initial,
  fallbackLocale: "ar",
  messages,
});

function toggleCss(isRtl) {
  if (typeof document === "undefined") return;
  const rtlIds = ["css-plugins-rtl", "css-style-rtl", "css-prism-rtl"];
  const ltrIds = ["css-plugins-ltr", "css-style-ltr", "css-prism-ltr"];
  rtlIds.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.disabled = !isRtl;
  });
  ltrIds.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.disabled = isRtl;
  });
}

function ensureDirSwitchStyle() {
  if (typeof document === "undefined") return;
  const STYLE_ID = "dir-switch-style";
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    html.dir-switching { visibility: hidden; }
    html.dir-switching *,
    html.dir-switching *::before,
    html.dir-switching *::after { transition: none !important; animation: none !important; }
    html.dir-switching img, html.dir-switching video { transform: none !important; }
  `;
  document.head.appendChild(style);
}

function applyDir(locale) {
  if (typeof document !== "undefined") {
    const isRtl = locale === "ar";
    ensureDirSwitchStyle();
    const html = document.documentElement;
    html.classList.add("dir-switching");
    html.classList.toggle("dir-rtl", isRtl);
    html.classList.toggle("dir-ltr", !isRtl);
    html.setAttribute("dir", isRtl ? "rtl" : "ltr");
    html.style.direction = isRtl ? "rtl" : "ltr";
    document.body && document.body.classList.toggle("rtl", isRtl);
    toggleCss(isRtl);
    // Remove the disabling class on the next frame(s) to avoid flicker
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        html.classList.remove("dir-switching");
      });
    });
  }
}

applyDir(initial);

export function switchLocale(locale) {
  const target = ["ar", "en"].includes(locale) ? locale : "ar";
  i18n.global.locale.value = target;
  try {
    localStorage.setItem("locale", target);
  } catch (e) {}
  applyDir(target);

  // Dispatch event to notify other modules about language change
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("languageChanged", { detail: { locale: target } })
    );
  }
}

export default i18n;
